import { render } from "./VirtualWarehouse.vue?vue&type=template&id=f76332a4&scoped=true"
import script from "./VirtualWarehouse.vue?vue&type=script&lang=js"
export * from "./VirtualWarehouse.vue?vue&type=script&lang=js"

import "./VirtualWarehouse.vue?vue&type=style&index=0&id=f76332a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76332a4"]])

export default __exports__